import React from "react";
import * as ButtonStyles from "../../../styles/v2/toyota/components/Button";
import * as Text from "../../../styles/v2/toyota/utilities/Text";
import { UspIconWrapper, IconWrapper } from "../../../styles/v2/toyota/globals/IconWrapper";
import Icon, { IconBuy, IconPhone, IconCarExchange, IconArrowRight } from "../../../styles/v2/toyota/globals/Icon";
import { LineClamp } from "../../../styles/v2/toyota/utilities/LineClamp";

export enum CtaIcon {
    Buy = "buy",
    Reserve = "reserve",
    Dealer = "dealer",
    Phone = "phone",
    Back = "back",
    Finance = "finance",
    Insurance = "insurance",
    Card = "card",
    CarExchange = "car-exchange",
}

type ButtonProps = {
    href?: string;
    onClick?: (event: any) => void;
    disabled?: boolean;
    fullWidth?: boolean;
    target?: string;
    rel?: string;
    classNames?: string;
    children: React.ReactNode;
    iconVariant?: CtaIcon;
};

const iconMap: Record<CtaIcon, React.ReactNode> = {
    [CtaIcon.Back]: <Icon variant="arrowLeft" size="medium" />,
    [CtaIcon.Dealer]: <Icon variant="location" size="medium" />,
    [CtaIcon.Phone]: <IconPhone width="40" height="40" viewBox="0 0 20 20" />,
    [CtaIcon.Reserve]: <Icon variant="reserve" size="medium" />,
    [CtaIcon.Buy]: <IconBuy width="40" height="40" viewBox="0 0 22 22" />,
    [CtaIcon.Finance]: <Icon variant="finance" size="medium" />,
    [CtaIcon.Insurance]: <Icon variant="insurance" size="medium" />,
    [CtaIcon.Card]: <Icon variant="card" size="medium" />,
    [CtaIcon.CarExchange]: <IconCarExchange width="40" height="40" viewBox="0 0 40 40" />,
};

/**
 * ButtonCta - Button Outline style with icon
 * @example
 *   <ButtonCta icon={iconVariant}>
 *     {label}
 *   </ButtonCta>
 */
const ButtonCta = (props: ButtonProps): JSX.Element => {
    const { href, onClick, disabled, fullWidth, children, target, classNames, rel, iconVariant } = props;

    return (
        <ButtonStyles.ButtonCta
            fullWidth={fullWidth}
            hasUspIcon={!!iconVariant}
            className={[classNames || "", disabled ? "disabled" : ""].join(" ")}
        >
            <Text.Button
                as={href ? "a" : "button"}
                role={href ? "link" : "button"}
                href={href && !disabled ? href : undefined}
                type={!href ? "button" : undefined}
                className={[classNames || "", disabled ? "disabled" : ""].join(" ")}
                disabled={!href && disabled}
                aria-disabled={disabled || undefined}
                target={href ? target : undefined}
                rel={href && rel}
                onClick={onClick}
            >
                {iconVariant && <UspIconWrapper size={40}>{iconMap[iconVariant]}</UspIconWrapper>}
                <LineClamp lines={2}>{children}</LineClamp>
                <IconWrapper>
                    <IconArrowRight />
                </IconWrapper>
            </Text.Button>
        </ButtonStyles.ButtonCta>
    );
};

export default ButtonCta;
